import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./Thankyouscreen.module.css";

const ThankYou = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <h2 className={styles.title}>🎉 Thank You!</h2>

        <p className={styles.text}>
          Thanks for participating in the Health Assessment 💙
        </p>

        <button
          className={styles.button}
          onClick={() => navigate("/health-assessment")}
        >
          Participate Again
        </button>
      </div>
    </div>
  );
};

export default ThankYou;